import { gql } from "@apollo/client";

const GET_PROGRAM = gql`
  query getProgram($productId: String, $currency: String, $language: String) {
    plan(productId: $productId, currency: $currency, language: $language) {
      id
      name
      costCategory
      packageDuration
      price
      credits
      currency
      filter
      type
    }
  }
`;

export default GET_PROGRAM;
